import { render, staticRenderFns } from "./SettingsNotifications.vue?vue&type=template&id=316e1d42&scoped=true&"
import script from "./SettingsNotifications.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316e1d42",
  null
  
)

export default component.exports